import colors from '../colors';
import * as React from 'react';
import styled, { css, StyledFunction } from 'styled-components';
import { Message } from '../../typedefs/store';
import ChoiceButtonList from './ChoiceButtonList';
import AnonymousAvatar from './AnonymousAvatar';

interface Props {
    message: Message;
}

const Message: React.SFC<Props> = ({ message }) => (
    <PresenceWrapper>{message.text}</PresenceWrapper>
);

export default Message;

const PresenceWrapper = styled.div`
    color: ${colors.mediumDarkGray};
    font-size: 12px;
    margin-bottom: 15px;
    text-align: center;
    &:last-child {
        margin-bottom: 0;
    }
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/PresenceMessage.tsx